import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

const classNames = {
  content: `DetailsContent`,
  details: `DetailsCards`,
  footer: `DetailsFooter`,
  participants: `DetailsParticipants`,
  pivot: `DetailsPivot`,
  pivotItem: `DetailsPivotItem`,
  root: `DetailsRoot`,
  toolbar: `DetailsToolbar`
};

export function useDetailsStyles() {
  const { spacing } = useTheme();
  const styleSet = useMemo(
    () => mergeStyleSets({
      details: [
        classNames.details,
        {
          height: `auto`,
          marginTop: spacing.l1,
          overflowY: `auto`
        }
      ],
      root: [
        classNames.root,
        {
          height: `100%`
        }
      ],
      content: [
        classNames.content,
        {
          height: `100%`,
          overflowY: `hidden`
        }
      ],
      pivot: [
        classNames.pivot,
        {
          height: `100%`,
          "& > div:nth-child(2)": {
            height: `calc(100% - 50px)`, // 44px is the height of the pivot header
            overflowY: `scroll`
          }
        }
      ],
      pivotItem: [
        classNames.pivotItem,
        {
          display: `flex`,
          flexDirection: `column`,
          height: `100%`
        }
      ],
      participants: [
        classNames.participants,
        {
          marginTop: spacing.l1,
          overflowY: `auto`
        }
      ],
      toolbar: [
        classNames.toolbar,
        {
          width: `50%`
        }
      ],
      footer: [
        classNames.footer,
        {
          padding: `0 ${spacing.m}`
        }
      ]
    }),
    [spacing]
  );
  return styleSet;
}
